
import common from "@/assets/js/Common.js";
import api from "@/assets/js/Api.js";
import mainMenuTab from '@/components/mainMenuTab'
import Confirm from 'vux/src/components/confirm/index.vue'



export default {

components: {
mainMenuTab,
Confirm
},
data(){
return {
addr:{
showConfirm:false,
store:null
},
shopTypeList:[],
searchContent:'',
}
},
methods:{

goupPage(){
this.$router.go(-1)
},

CheckInfo(){
let _this = this;
if (event.keyCode == 13) {
_this.$router.push({name: "search",query: {sContent: _this.searchContent}});

}

},

queryGoodsTypeList(caryid){
let _this = this;
let opts = {
url: api.supplierList,
data:{
id: caryid
},
type:'get'
};
common.query(opts).then(res => {
this.shopTypeList = res.data
},res => {
this.$vux.toast.text(res.message);
});
},

shopDetail(id){

this.$router.push({name: "store",query: {storeId: id}});
},
showStore()
{
let id = this.addr.store.store_id;
this.$router.push({name: "store",query: {storeId: id}});
},
addAddr()
{
this.$router.push('/member/address');
}




},
mounted(){
this.queryGoodsTypeList(this.$route.query.caryid)

},
}



// WEBPACK FOOTER //
// ./src/views/pages/storeList.vue